import { Type } from '@angular/core';
import { DialogService, DynamicDialogConfig } from 'primeng/dynamicdialog';

const BASE_CONFIG: DynamicDialogConfig = {
  modal: true,
  resizable: false,
  draggable: false,
  closeOnEscape: true,
  closable: false,
};

export function openSmallDialog(
  dialogService: DialogService,
  component: Type<unknown>,
  options: DynamicDialogConfig = {},
) {
  return dialogService.open(component, {
    ...BASE_CONFIG,
    width: '450px',
    breakpoints: { '960px': '75vw', '640px': '90vw' },
    ...options,
  });
}

export function openMediumDialog(
  dialogService: DialogService,
  component: Type<unknown>,
  options: DynamicDialogConfig = {},
) {
  return dialogService.open(component, {
    ...BASE_CONFIG,
    width: '40vw',
    breakpoints: { '960px': '75vw', '640px': '90vw' },
    ...options,
  });
}

export function openLargeDialog(
  dialogService: DialogService,
  component: Type<unknown>,
  options: DynamicDialogConfig = {},
) {
  return dialogService.open(component, {
    ...BASE_CONFIG,
    width: '50vw',
    breakpoints: {
      '1560px': '50vw',
      '1280px': '55vw',
      '960px': '90vw',
      '640px': '90vw',
    },
    ...options,
  });
}
